import { useState, useEffect, useContext } from 'react'
import { enqueueSnackbar } from 'notistack'
import _ from 'lodash'

import { AppContext } from '/providers/app-context'
import { updatePass } from '/providers/passes-api'

import getLeafNodes from '/utils/get-leaf-nodes'

import { Button, TextField } from '@mui/material'

const EditForm = ({ pass, templateId, setPass }) => {

  const { apiSource, apiKeys, setProcessing } = useContext(AppContext)

  const [editableFields, setEditableFields] = useState([])
  const [newData, setNewData] = useState({})
  const [originalInstanceData, setOriginalInstanceData] = useState({})

  useEffect(() => {
    if (pass) {
      setOriginalInstanceData(pass.instance_data)

      const ln = getLeafNodes(pass.instance_data)

      const ef = ln.filter(n => {
        const branch = n.split(".").shift()
        return !branch.match(/__PASS_ID__/) // Cannot change pass_id !!!
      })

      setEditableFields(ef)
      setNewData(_.cloneDeep(pass.instance_data))
    }
  }, [pass])


  const setField = (node, value) => {
    let d = _.cloneDeep(newData)
    _.set(d, node, value)
    setNewData(d)
  }

  const save = async () => {
    setProcessing(true)
    enqueueSnackbar({ message: 'Saving new pass data', variant: 'light' })
    const result = await updatePass({ apiSource, apiKeys, templateId, passId: pass.pass_id, instance_data: newData })

    if (result.pass) {
      enqueueSnackbar({ message: 'New pass data saved', variant: 'success' })
      setPass(result.pass)
    } else {
      enqueueSnackbar({ message: (result.error.message ?? result.error) ?? "Unknown error", variant:'error' })
    }

    setProcessing(false)
  }

  return (
    <div className='flex flex-col gap-5'>
      {editableFields.map(node =>
        <EditField key={node} node={node} originalInstanceData={originalInstanceData} newData={newData} setField={setField} />
      )}
      <div className='mt-10 flex w-full justify-between gap-10'>
        <div>Ensure your data is correct before you save. When you save, this pass will be updated and
          the new content will be pushed to any devices this pass is installed on. Pay special attention
          to <b>dates and times</b> to ensure they are in the correct format, and that mail / telephone links <b>do not include
            mailto: / tel:</b>, but that web links do include <b>http://</b> or <b>https://</b>. Failure to ensure this data is
          correct can result in incorrect display and/or functionality of this pass.
        </div>
        <Button onClick={save} variant='contained' disabled={_.isEqual(originalInstanceData, newData)}>Save</Button>
      </div>
    </div>
  )
}
export default EditForm

const EditField = ({ node, originalInstanceData, newData, setField }) => {
  try {
    const originalValue = _.get(originalInstanceData, node).toString()

    const isImage = originalValue ? originalValue.match(/s3\.eu-west-1\.amazonaws.com\/images.smartix.uk/)?.length > 0 : false

    return (
      <div className='flex flex-row gap-5'>

        {!isImage && <TextField className='w-full' value={_.get(newData, node)} label={node} helperText={"original value: " + originalValue} onChange={e => setField(node, e.target.value)} />}

      </div>
    )
  }
  catch (err) {
    console.log(err)
  }
}